// src/resources/entityReports/EntityReportActionsField.js
import * as React from 'react';
import { useRecordContext } from 'react-admin';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    TextField,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import useModerationAction from '../../hooks/useModerationAction';
import { updateEntityReportStatus } from '../../services/entityReports';
import { ENTITY_REPORT_STATUS_CONFIG } from './constants';

const STATUS_ACTIONS = ENTITY_REPORT_STATUS_CONFIG.filter(({ status }) => status !== 'NEW');

const extractEntityId = (record) => {
    if (!record?.id) return null;
    const value = String(record.id);
    if (value.includes(':')) {
        return value.split(':')[1];
    }
    return value;
};

export default function EntityReportActionsField({ variant = 'list', record: recordFromProps }) {
    const contextRecord = useRecordContext();
    const record = recordFromProps || contextRecord;
    const entityId = extractEntityId(record);
    const entityType = record?.type;
    const { loading, run } = useModerationAction();
    const [dialog, setDialog] = React.useState(null);
    const [note, setNote] = React.useState('');

    if (!record) return null;

    const openDialog = (status) => {
        setDialog({ status });
        setNote('');
    };

    const closeDialog = () => {
        if (loading) return;
        setDialog(null);
        setNote('');
    };

    const submit = async () => {
        if (!dialog?.status || !entityType) return;
        await run({
            id: entityId,
            request: () => updateEntityReportStatus(entityType, entityId, {
                status: dialog.status,
                note: note.trim() || null,
            }),
            successMessage: `Statut mis à jour (${dialog.status})`,
            onSuccess: closeDialog,
        });
    };

    const buttonSize = variant === 'show' ? 'medium' : 'small';

    return (
        <>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                {STATUS_ACTIONS.map(({ status, label }) => (
                    <Button
                        key={status}
                        size={buttonSize}
                        variant="outlined"
                        disabled={loading}
                        onClick={(event) => {
                            event.stopPropagation?.();
                            openDialog(status);
                        }}
                    >
                        {loading ? <CircularProgress size={14} /> : label}
                    </Button>
                ))}
            </Stack>

            <Dialog
                open={Boolean(dialog)}
                onClose={closeDialog}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Mettre à jour le statut</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Le signalement sera marqué « {dialog?.status} ».
                    </DialogContentText>
                    <TextField
                        label="Note interne"
                        value={note}
                        onChange={(event) => setNote(event.target.value)}
                        fullWidth
                        multiline
                        minRows={3}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} disabled={loading}>
                        Annuler
                    </Button>
                    <Button onClick={submit} variant="contained" disabled={loading}>
                        {loading ? <CircularProgress size={18} sx={{ color: 'white' }} /> : 'Confirmer'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
